import React, { useRef } from 'react'
import { Icon } from 'semantic-ui-react'
import { DatasetConfig } from '../../../types'
import { FormDataset, mapToFormDataset, Dataset } from '@confluent-cfet-medusa/dataset-designer'
import { StyledButton } from '../../common/styledComponents'
import GoogleFormBtn from './GoogleFormBtn'

interface HeaderProps {
  setDatasetDesignerFormData: React.Dispatch<React.SetStateAction<FormDataset>>
  setDatasetConfig: React.Dispatch<React.SetStateAction<DatasetConfig>>
  sourceIsTerrasnap: boolean
}

const Header = (props: HeaderProps) => {
  const { setDatasetDesignerFormData, setDatasetConfig, sourceIsTerrasnap } = props

  const fileInputRef = useRef<HTMLInputElement | null>(null)

  const setFormDatasetFromDatasetConfig = (datasetConfig: DatasetConfig) => {
    const dataset: Dataset = datasetConfig.dataset
    const convertedFormDataset: FormDataset = mapToFormDataset(dataset)
    setDatasetDesignerFormData(convertedFormDataset)
  }

  const handleDatasetConfigFileUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files ? event.target.files[0] : undefined
    if (file) {
      const reader = new FileReader()
      reader.onload = (e: ProgressEvent<FileReader>) => {
        try {
          const parsedDataset = JSON.parse(e.target?.result as string) as Dataset

          const datasetConfig = {
            dataset: parsedDataset,
          }

          setFormDatasetFromDatasetConfig(datasetConfig)

          setDatasetConfig(datasetConfig)
        } catch (error) {
          console.error('Failed to parse JSON from uploaded file:', error)
          alert(
            'The uploaded file contains invalid JSON. Please upload a valid dataset configuration file.'
          )
        }
      }

      reader.readAsText(file)
    }

    // Reset file input
    if (event.target) {
      event.target.value = ''
    }
  }

  const onFileUpload = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click()
    }
  }

  return (
    <div
      style={{
        width: '100%',
        maxWidth: '1600px',
        overflow: 'visible',
        display: 'flex',
        flexDirection: 'row',
        paddingTop: '50px',
        paddingBottom: '0px',
        paddingLeft: '40px',
        paddingRight: '40px',
        justifyContent: 'space-between',
        alignItems: 'center',
        color: 'white',
        fontSize: '2em',
      }}
    >
      <div style={{ display: 'flex', flex: '0 0 auto', alignItems: 'center' }}>
        <img
          src="/images/confluent_logo-mark-meadow.svg"
          width={40}
          height={40}
        />
        <span style={{ color: '#03ABE5', fontStyle: 'italic', paddingLeft: '5px' }}>Mock</span>
        <span style={{ color: '#eee' }}>stream</span>
      </div>
      <div style={{ flex: '0 0 auto', display: 'flex', gap: '3%' }}>
        <input
          type="file"
          onChange={handleDatasetConfigFileUpload}
          style={{ display: 'none' }}
          ref={fileInputRef}
        />
        <div style={{ display: 'flex', flexDirection: 'row', gap: '10px' }}>
          {!sourceIsTerrasnap && (
            <StyledButton onClick={onFileUpload}>
              <Icon name="upload" />
              Upload Dataset
            </StyledButton>
          )}
        </div>
        <GoogleFormBtn />
      </div>
    </div>
  )
}

export default Header
